export const TOKEN_STORAGE_FIELD = "token";
export const REFRESH_TOKEN_STORAGE_FIELD = "refresh_token";
